import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import 'rxjs/add/operator/map';

declare const window;
@Injectable()
export class ChatSupportService {
	private unread = 0;
	private open = false;

	constructor(
		private platform: Platform,
	) {
	}

	set isOpen(value) {
		this.open = value;
	}

	get isOpen() {
		return this.open;
	}

	set unreadMessage(value) {
		this.unread = value;
	}

	get unreadMessage() {
		return this.unread;
	}

	async initZendesk() {
		if (this.platform.is('cordova')) {
			await this.initZendeskNative();
		}
		// else {
		// 	await this.initZendeskWeb();
		// 	this.hideButtonLauncher();
		// 	this.onClose();
		// }
	}

	// private async initZendeskWeb() {
	// 	const config: any = {
	// 		accountUrl: 'greatdayhrsupport.zendesk.com',
	// 		lazyLoad: true,
	// 		timeOut: 3000,
	// 		injectionTag: 'head',
	// 		callback: null
	// 	}

	// 	if (!this.ngxZendeskWebwidgetService.isInitialized()) {
	// 		await this.ngxZendeskWebwidgetService.initZendesk(config);
	// 	}
	// }

	private initZendeskNative() {
		if (this.platform.is('cordova')) {
			const zendeskUrl = 'https://greatdayhrsupport.zendesk.com';
			const appId = '7d3555fbb4869a2663ba2622b520e6a4645ea3f0a9bac184';
			const clientId = 'mobile_sdk_client_11d8421d108b7c141319';

			window.plugins.Zendesk.initialize(appId, clientId, zendeskUrl, (success) => {
				console.log('zendesk init success', success);
			}, error => {
				console.log('zendesk init error', error);
			});
		}
	}

	hideButtonLauncher(custom = false) {
		if (this.platform.is('android') || this.platform.is('ios')) {
			this.hideDefaultButtonChat();
			this.hideSuggestionChat();
			this.hideDefaultBadgeUnreadMessage();
		}
		if (custom) {
			this.hideDefaultButtonChat();
			this.hideSuggestionChat();
			this.hideDefaultBadgeUnreadMessage();
		}
	}

	setZIndex(index: number) {
		// this.ngxZendeskWebwidgetService.zE('messenger:set', 'zIndex', index);
	}

	showChat() {
		if (this.platform.is('cordova')) {
			this.showChatNative();
		} else {
			// this.ngxZendeskWebwidgetService.zE('messenger', 'open');
		}
	}

	hideChat() {
		this.isOpen = false;
		// this.ngxZendeskWebwidgetService.zE('messenger', 'close');
	}

	logoutUser() {
		// this.ngxZendeskWebwidgetService.zE('messenger', 'logoutUser');
		this.unreadMessage = 0;
	}

	onClose() {
		// this.ngxZendeskWebwidgetService.zE('messenger:on', 'close', () => {
		// 	this.hideButtonLauncher();
		// 	this.ngZone.run(() => {
		// 		setTimeout(() => {
		// 			this.isOpen = false;
		// 		}, 1000);
		// 	})
		// })
	}

	onOpen() {
		// this.ngxZendeskWebwidgetService.zE('messenger:on', 'open', () => {
		// 	console.log('on open');
		// 	this.hideDefaultButtonChat();
		// 	this.hideSuggestionChat();

		// 	this.ngZone.run(() => {
		// 		this.isOpen = true;
		// 	});
		// });
	}

	listenUnReadMessage() {
		// this.ngxZendeskWebwidgetService.zE('messenger:on', 'unreadMessages', (count) => {
		// 	this.ngZone.run(() => {
		// 		this.unreadMessage = count;
		// 		if (count) {
		// 			this.hideDefaultBadgeUnreadMessage();
		// 		}
		// 	});
		// });
	}

	hideDefaultButtonChat() {
		let count = 1;
		const interval = setInterval(() => {
			try {
				const titleId = document.querySelectorAll('[title="Tombol untuk meluncurkan jendela pesan"]');
				const titleEn = document.querySelectorAll('[title="Button to launch messaging window"]');

				if (titleId && titleId.length) {
					const elementId = titleId[0] as HTMLElement;
					elementId.style.display = 'none';
					clearInterval(interval);
				}

				if (titleEn && titleEn.length) {
					const elementEn = titleEn[0] as HTMLElement;
					elementEn.style.display = 'none';
					clearInterval(interval);
				}

				// check sampai 3 detik, mencegah interval panjang
				if (count >= 100) {
					clearInterval(interval);
				} else {
					count++;
				}
			} catch (e) {
				console.log(e);
			}
		}, 100);
	}

	hideSuggestionChat() {
		let count = 1;
		const interval = setInterval(() => {
			try {
				const titleId = document.querySelectorAll('[title="Pesan dari perusahaan"]');
				const titleEn = document.querySelectorAll('[title="Message from company"]');

				if (titleId && titleId.length) {
					const elementId = titleId[0] as HTMLElement;
					elementId.style.display = 'none';
					clearInterval(interval);
				}

				if (titleEn && titleEn.length) {
					const elementEn = titleEn[0] as HTMLElement;
					elementEn.style.display = 'none';
					clearInterval(interval);
				}

				// check sampai 3 detik, mencegah interval panjang
				if (count >= 100) {
					clearInterval(interval);
				} else {
					count++;
				}
			} catch (e) {
				console.log(e);
			}
		}, 100);
	}

	hideDefaultBadgeUnreadMessage() {
		let count = 1;
		const interval = setInterval(() => {
			try {
				const titleId = document.querySelectorAll('[title="Jumlah pesan yang belum dibaca"]');
				const titleEn = document.querySelectorAll('[title="Number of unread messages"]');

				if (titleId && titleId.length) {
					const elementId = titleId[0] as HTMLElement;
					elementId.style.display = 'none';
					clearInterval(interval);
				}

				if (titleEn && titleEn.length) {
					const elementEn = titleEn[0] as HTMLElement;
					elementEn.style.display = 'none';
					clearInterval(interval);
				}

				// check sampai 3 detik, mencegah interval panjang
				if (count >= 100) {
					clearInterval(interval);
				} else {
					count++;
				}
			} catch (e) {
				console.log(e);
			}
		}, 100);
	}

	/**
	 * ZENDESK NATIVE
	 */
	showChatNative() {
		if (this.platform.is('cordova')) {
			window.plugins.Zendesk.showHelpCenter(['Support'], [''], [''], (success) => {
				console.log('zendesk showHelpCenter success', success);
			}, error => {
				console.log('zendesk showHelpCenter error', error);
			});
		}
	}

	setIdentity(name: string, email: string) {
		if (this.platform.is('cordova')) {
			return new Promise(resolve => {
				window.plugins.Zendesk.setAnonymousIdentity(name, email, (success) => {
					resolve(success);
				}, error => {
					resolve(error);
				});
			});
		}
	}

}



// WEBPACK FOOTER //
// ./src/providers/chat-support/chat-support-service.ts